import React from 'react';

import FlatButton from 'material-ui/FlatButton'
import NavigationMenuIcon from 'material-ui/svg-icons/navigation/menu';


const rootStyle = {
  /*position: 'relative',*/
  position: 'fixed',
  top: 0,
  width: '100%',
  height: 54,
  zIndex: 2,
  background: '#1AC6FF',
  overflow: 'hidden',
};


const btnStyle = {
  position: 'absolute',
  top: 6,
  minWidth: 60,
  height: 42,
  lineHeight: '42px',
  color: '#fff',
};


const contentStyle = {
  position: 'absolute',
  top: 0,
  left: 60,
  height: '100%',
};


export default class StashAppBar extends React.Component {

  render() {
    const { children } = this.props;
    const spacer = this.props.spacer || false;
    return (
      <div>
        <div style={rootStyle}>
          <FlatButton
            icon={<NavigationMenuIcon />}
            style={btnStyle}
            title="Show/Hide side bar"
            onTouchTap={e => {console.log('Navigation');}}
          />
          <div style={contentStyle}>{children}</div>
        </div>
        {spacer && (
          <div style={{height: rootStyle.height}}></div>
        )}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/StashAppBar.jsx